import requests from "./httpService";

const AddonsServices = {

    getAddons: async () =>{
        return requests.get(`/addons`);
    },
    updateAddons : async (id,body) =>{
        return requests.patch(`/addons/${id}`,body);
    },

    createAddons : async (body) =>{
        // console.log(body)
        return requests.post(`/addons`,body);
    },
    deleteAddons : async (id) =>{
        return requests.delete(`/addons/${id}`);
    }
}
export default AddonsServices;